const config = {
    api: {
        base: 'https://api-lunchie-production.ack.ee/api',
    },
};

export default config;
